
import ReactDOM from 'react-dom/client'
import React from 'react'
import './styles.css'
import * as THREE from 'three'
import { useRef } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { OrbitControls, Edges, Center, Instances, Instance, Bounds } from '@react-three/drei'
import Colors from './Colors'
import * as Tone from 'tone'
import anime from 'animejs/lib/anime.es.js';

const randI = (i) => Math.floor(i * fxrand())
const rand = (arr) => arr[randI(arr.length)]
const lerp = THREE.MathUtils.lerp
const mobile = window.innerWidth < 600

const ci = randI(Colors.length)
const colors = Colors[ci]
const bgColor = colors.shift()
const cols = colors
const accent = cols[1]

const feats = window.$fxhashFeatures = {
  chords: rand([7, 8, 8, 8, 9, 10, 11, 12]),
  color: ci,
  petals: 3 + randI(13),
  family: randI(100) > 92,
  wild: randI(100) > 94,
  bpm: rand([80,80,85,85,85,90]),
}

Tone.Transport.bpm.value = feats.bpm
console.table(feats)

const defaultOpacity = feats.wild ? 0.15 : 0.4
let mainUnit = '4n';

let filters = []
let pans = []
const instNotes = ['A2', 'C3', 'E3', 'G3', 'A3', 'C4', 'D4', 'E4']
let pansAmt = 8
let spread = 1.4
new Array(pansAmt).fill().map((_, i) => {
  pans[i] = new Tone.AutoPanner(0.25 + (i * 0.125)).start().toDestination()
  pans[i].depth.value = 0.6
  filters[i] = new Tone.Filter(1000 + (15 * randI(10)), "bandpass", -24).connect(pans[i])
})

const insts = {};

instNotes.forEach((n, i) => {
  insts[n] = new Tone.Sampler({
    urls: {
      C3: "./teropa/scale-" + n + ".mp3",
    },
  })

  insts[n].attack = 0 + (fxrand() * 2)
  insts[n].release = 1 + (fxrand() * 4)
  insts[n].volume.value = 0
  insts[n].connect(filters[i % pansAmt])
})
const mods = [4, 6, 8, 8, 5, 5, 6]
const loopMods = []
const opacities = []
const opacitiesTarget = []
const progress = {}

const r = []
new Array(feats.chords).fill().map((_, i) => ((i === 0) || rand([true, true, false])) && r.push(Tone.Time(mainUnit).toSeconds() * i))
const loopTime = Tone.Time(mainUnit).toSeconds() * feats.chords
const getVel = () => (3.3 + (randI(10) * 0.01))
const seqs = [
  r.map((time, i) => ({
    time,
    velocity: getVel() * (i == 0 ? 1 : rand([0, 0, 0, 1])),
    i,
    seq: 0,
    oct: rand([-1, -1, -1, -1]),
  })),
  r.map((time, i) => ({
    time,
    velocity: getVel() * rand([0, 0, 0, 0, 1]),
    i,
    seq: 1,
    oct: rand([-1, -1, -1, -1]),
  })),
  r.map((time, i) => ({
    time,
    velocity: getVel() * rand([0, 0, 0, 0, 1]),
    i,
    seq: 2,
    oct: -1,
  })),
  r.map((time, i) => ({
    time,
    velocity: getVel() * rand([0, 0, 0, 1]),
    i,
    seq: 3,
    oct: -1,
  })),
  r.map((time, i) => ({
    time,
    velocity: getVel() * rand([0, 0, 0, 0, 1]),
    i,
    seq: 4,
    oct: -1,
  })),
  r.map((time, i) => ({
    time,
    velocity: getVel() * rand([0, 0, 0, 1]),
    i,
    seq: 5,
    oct: -1,
  })),
  r.map((time, i) => ({
    time,
    velocity: getVel() * rand([0, 0, 0, 1]),
    i,
    seq: 6,
    oct: -1,
  })),
]
let notes = []
let s1 = randI(3), s2 = randI(3);
notes[0] = seqs.map((s, i) => r.map((_, i) => instNotes[(i + s1) % instNotes.length]))
notes[1] = seqs.map((s, i) => r.map((_, i) => instNotes[(i + s2) % instNotes.length]))

seqs.forEach((v, i) => {
  opacities[i] = defaultOpacity
  opacitiesTarget[i] = defaultOpacity
  progress['p' + i] = 1
  loopMods[i] = mods[i]
})

let doProgress = (i) => {
  progress['p' + i] = 0
  anime({
    targets: progress,
    ['p' + i]: 1,
    easing: 'linear',
    duration: loopTime * loopMods[i] * 400,
    delay: loopTime * loopMods[i] * 300
  })
}
let modCount = 3;
let rotSpeed = 0;
let delayUnit = Tone.Time('64n').toSeconds()
let part = new Tone.Part(((time, { velocity, i, seq, oct }) => {
  let n = notes[0]
  if (!i && seq === 0) {
    modCount++;
    loopMods.forEach((mod, i) => {
      if (modCount % (mod) === 0) {
        doProgress(i)
      }
    })
  }
  if (!velocity) {
    return
  }
  if (modCount !== 0 && modCount % 16 === 0) {
    n = notes[1]
  }
  if (modCount === 3) {
    instNotes.forEach((n, i) => {
      insts[n].volume.value = 0
    })
  }
  if ((modCount % loopMods[seq] === 0)) {
    opacitiesTarget[seq] = defaultOpacity + 0.55
    insts[n[seq][i]].triggerAttackRelease('C' + (3 + oct), loopTime * loopMods[seq], time, velocity);
    if (rand[true, true, false]) {
      insts[n[seq][(i + 1) % n[seq].length]].triggerAttackRelease('C' + (3 + oct), loopTime * loopMods[seq], time + (delayUnit * (randI(0))), velocity);
    }
  }
}), seqs.flat())
part.loop = true
part.loopEnd = loopTime

let started = false;
export default function App() {
  const start = () => {
    if (Tone.Transport.state !== 'started') {
      Tone.start();
      Tone.Transport.start();
      part.start();
      rotSpeed = 0.1
      started = true
    }
  }
  return (
    <div id="main" onClick={() => start()}>
      <Canvas dpr={[1, 2]} camera={{ near: 0.00001, position: [0, 0, feats.wild ? -0.5 : -0.45], fov: 15 }}>
        <Flowers />
        <OrbitControls autoRotate autoRotateSpeed={0} rotateSpeed={1.5} dampingFactor={0.005} maxDistance={2} minDistance={0.14} />
      </Canvas>
    </div>
  )
}

let trans1 = rand([0, 0, 0, 0, 0, 0, 0, 0, 0.003, 0.004, 0.0025, 0.01, 0.015]);
let trans2 = rand([0, 0, 0, 0, 0, 0, 0, 0, 0.003, 0.004, 0.0025, 0.01, 0.015]);

function Flowers() {
  useFrame(() => {
    opacities.forEach((v, i) => {
      opacities[i] = lerp(opacities[i], opacitiesTarget[i], 0.05)
      opacitiesTarget[i] = lerp(opacitiesTarget[i], defaultOpacity, 0.01)
    })
  })

  const top1 = new THREE.CircleBufferGeometry(0.008, 3);
  top1.rotateY(Math.PI)
  top1.scale(0.5, 1, 1)
  top1.translate(0.0048, trans1, 0.0)

  const top2 = new THREE.CircleBufferGeometry(0.008, 12, Math.PI * 0.5, Math.PI);
  top2.scale(0.5, 1, 1)
  top2.translate(0.0048, trans2, 0)

  const top3 = new THREE.CircleBufferGeometry(0.008, 12, Math.PI * 0.5, Math.PI);
  top3.scale(1.2, 0.2, 0.2)
  top3.translate(0.01, 0, 0)

  const ball = new THREE.OctahedronBufferGeometry(0.00075, 4)
  ball.scale(1.5, 1.5, 1.5)

  const aScale = 0.0004
  const alongGeo = new THREE.BoxBufferGeometry(aScale, aScale, aScale)
  return (
    <Bounds margin={(mobile && !feats.family) ? 1 : 1.3} damping={false} fit>
      <Center>
        <group rotation={[0, -0.5, 0]}>
          {feats.family ?
            <>
              {new Array(rand([5, 6, 7])).fill().map((_, i) =>
                <Flower seq={i} len={0.2 + (i * 0.09)} key={i} topGeo={rand([top1, top2, top1, top2, top1, top2, top1, top2, top3])} ballGeo={rand([ball])} alongGeo={rand([alongGeo])} wheatGeo={rand([alongGeo])} />
              )}
              <group position={[rand([0.04, 0.05, 0.035]) * rand([1, -1]), 0, -rand([0.02, 0])]} scale={[0.8, 0.8, 0.8]}>
                {new Array(rand([2, 3])).fill().map((_, i) =>
                  <Flower seq={i} len={0.3 + (i * 0.09)} key={i} topGeo={rand([top1, top2, top1, top2, top1, top2, top1, top2, top3])} ballGeo={rand([ball])} alongGeo={rand([alongGeo])} wheatGeo={rand([alongGeo])} />
                )}
              </group>
              {rand([true, false]) &&
                <group position={[rand([0.01, 0.02, 0.02]), 0, -rand([0.03, 0.02, 0.05, 0])]} scale={[0.8, 0.8, 0.8]}>
                  {new Array(rand([1, 2])).fill().map((_, i) =>
                    <Flower seq={i} len={0.14 + (i * 0.09)} key={i} topGeo={rand([top1, top2, top1, top2, top1, top2, top1, top2, top3])} ballGeo={rand([ball])} alongGeo={rand([alongGeo])} wheatGeo={rand([alongGeo])} />
                  )}
                </group>
              }
            </> :
            <>
              {new Array(rand([5, 6, 7])).fill().map((_, i) =>
                <Flower seq={i} len={0.15 + (i * 0.09)} key={i} topGeo={rand([top1, top2, top1, top2, top1, top2, top1, top2, top3])} ballGeo={rand([ball])} alongGeo={rand([alongGeo])} wheatGeo={rand([alongGeo])} />
              )}
              <Flower seq={1} len={0.48} topGeo={rand([top1, top2, top1, top2, top3])} ballGeo={rand([ball])} alongGeo={rand([alongGeo])} wheatGeo={rand([alongGeo])} />
              <Flower seq={1} len={0.24} topGeo={rand([top1, top2, top1, top2, top3])} ballGeo={rand([ball])} alongGeo={rand([alongGeo])} wheatGeo={rand([alongGeo])} />
              {rand([true, false]) &&
                <Flower seq={2} len={0.54} topGeo={rand([top1, top1, top2, top2, top1, top1, top2, top2, top3])} ballGeo={rand([ball])} alongGeo={rand([alongGeo])} wheatGeo={rand([alongGeo])} />
              }
            </>
          }
        </group>
      </Center>
    </Bounds>

  )
}
const rotDir = rand([1, -1])
const diameter = (1 + randI(4)) * 0.00825
const globalYMod = randI(2) + 1
function Flower({ amt, len, seq, topGeo, alongGeo, ballGeo, wheatGeo }) {
  const ref = useRef();
  const steps = feats.wild ? 70 : 160
  const yStep = feats.wild ? 0.0007 : 0.0003
  const rads = seq * rand([0.25, 0.125, 0.3, 0.4, 0.06])
  const yMod = 0.25 + randI(globalYMod) * 0.5 * (1 - len)
  const pow = feats.wild ? 3 : rand([1.2, 1.3, 2, 3])
  const waveData = new Array(steps).fill().map((_, i) => {
    const f = (i) / (steps - 1)
    let r = Math.min(Math.pow(f, pow), 1) * ((seq * 0.25) + 0.25)
    let r1 = r
    let r2 = r
    let r3 = 0
    if (feats.wild) {
      r1 = rand([r * 1.01, r * 1.04, r]) * rand([0.25, 1, 1, 1, 1, 1, 1])
      r2 = rand([r * 1.02, r * 1.01, r]) * rand([0.25, 1, 1, 1])
      r3 = rand([0, 0, 0, 0, 0, 0, 1, 2, 3, 4]) * rand([-1]) * 0.006 * r * len
    }
    return new THREE.Vector3(
      (Math.sin((f * Math.PI * rads)) * diameter * r1),
      (r3 + ((Math.sin(f * Math.PI * yMod) * 0.1) + (i * yStep))) * len,
      Math.cos((f * Math.PI * rads)) * diameter * r2
    )
  })
  let width = rand([0.0002, 0.0002, 0.0003, 0.0003, 0.0004, 0.0005]) * (feats.wild ? rand([2, 3, 4]) : 1)
  let width2 = 0.00005 * (feats.wild ? rand([1, 1.5, 2]) : 1)
  const spline = new THREE.CatmullRomCurve3(waveData, false, 'catmullrom', feats.wild ? 2 : 1);
  const pts = [], pts2 = [], numPts = 2;
  for (let i = 0; i < numPts * 2; i++) {
    const l = (i % 2 == 1 ? 1 : 2) * width * len;
    const l2 = (i % 2 == 1 ? 1 : 2) * width2;
    const a = i / numPts * Math.PI;
    pts.push(new THREE.Vector2(Math.cos(a) * l, Math.sin(a) * l));
    pts2.push(new THREE.Vector2(Math.cos(a) * l2, Math.sin(a) * l2));
  }

  const topTangent = spline.getTangentAt(1)
  const topPos = spline.getPointAt(1)
  const shape = new THREE.Shape(pts);
  const shape2 = new THREE.Shape(pts2);
  const extrudeGeo = new THREE.ExtrudeGeometry(shape, {
    steps: feats.wild ? 50 : 800,
    bevelEnabled: false,
    extrudePath: spline
  });
  const extrudeGeo2 = new THREE.ExtrudeGeometry(shape2, {
    steps: feats.wild ? 1000 : 800,
    bevelEnabled: false,
    extrudePath: spline
  });
  const col = cols[seq % cols.length]
  return (
    <group ref={ref}>
      <group position={[0, 0, 0]} rotation={[0, seq * Math.PI * 0.2 * rotDir, 0]}>
        <Wirl geo={extrudeGeo} geo2={extrudeGeo2} seq={seq} col={col} />
        {(feats.wild || rand([true, true, false]) && (len > 0.5)) ?
          (feats.wild || rand([true, false]) ?
            <Wheats spline={spline} geo={wheatGeo} len={len} seq={seq} col={col} width={(8 + randI(25)) * 3} />
            :
            <Alongs spline={spline} geo={alongGeo} len={len} seq={seq} col={col} width={feats.wild ? 10 : ((5 + randI(20)) * 3)} />
          )
          :
          (rand([true, true, true, true, true, true, false]) ?
            <Top topPos={topPos} topTangent={topTangent} geo={topGeo} seq={seq} col={col} len={len} />
            :
            <Balls topPos={topPos} topTangent={topTangent} geo={ballGeo} seq={seq} col={col} len={len} />
          )
        }
        <Track seq={seq} spline={spline} />
      </group>
    </group>
  )
}

function Wheats({ spline, geo, len, seq, col, width }) {
  const rows = Math.floor(30 * len);
  const columns = 4;
  const atScale = 0.05 + (fxrand() * 0.2)
  const modCol = rand([false, false, true])
  const rotDir = rand([1, -1])
  return (
    <Instances limit={10000} geometry={geo}>
      <meshBasicMaterial depthTest={false} renderOrder={200} />
      {new Array(rows).fill().map((_, r) =>
        new Array(columns).fill().map((_, c) =>
          <Wheat r={r} c={c} spline={spline} geo={geo} len={len} seq={seq} rows={rows} atScale={atScale} key={c} width={width} modCol={modCol} rotDir={rotDir} />
        )
      )}
    </Instances>
  )
}

function Wheat({ r, c, spline, rows, len, atScale, seq, width, modCol, rotDir }) {
  const ref = useRef();
  const inst = useRef();
  const at = 1 - (((1 / rows) * (r + 1)) * atScale)
  const p = spline.getPointAt(at)
  const t = spline.getTangentAt(at)
  useFrame((_, delta) => {
    ref.current.rotation.y += delta * rotSpeed * rotDir
  })
  const spread = (r <= (rows / 2) ? r : rows - r) * 0.5
  const s = (rand([0.1]) + ((spread) * 0.05)) * len
  return (
    <group position={[p.x, p.y, p.z]} rotation={[t.x, t.y, t.z]}>
      <group ref={ref}>
        <group rotation={[0, (r * 0.02) + ((Math.PI * 2) / 4) * c, 0]}>
          <group position={[0.0003 * (spread + 1), 0, 0]} scale={[s * width * 0.35, s, s * width * 0.25]}>
            <Instance ref={inst} renderOrder={500} color={modCol ? (r % 2 === 0 ? cols[1] : cols[0]) : accent} />
          </group>
        </group>
      </group>
    </group>
  )
}

function Alongs({ spline, geo, len, seq, col, width }) {
  const rows = Math.floor(70 * len);
  const columns = 1 + randI(2);
  const atScale = 0.1 + (fxrand() * 0.4)
  const modCol = rand([false, false, true])
  const rotDir = rand([1, -1])

  return (
    <Instances limit={10000} geometry={geo}>
      <meshBasicMaterial depthTest={false} renderOrder={200} />
      {new Array(rows).fill().map((_, r) =>
        new Array(columns).fill().map((_, c) =>
          <Along r={r} c={c} spline={spline} geo={geo} len={len} seq={seq} rows={rows} atScale={atScale} key={c} width={width} modCol={modCol} rotDir={rotDir} />
        )
      )}
    </Instances>
  )
}

function Along({ r, c, spline, rows, len, atScale, seq, width, modCol }) {
  const ref = useRef();
  const inst = useRef();
  const at = 1 - (((1 / rows) * (r + 1)) * atScale)
  const p = spline.getPointAt(at)
  const t = spline.getTangentAt(at)
  useFrame((_, delta) => {
    ref.current.rotation.y += delta * rotSpeed * rotDir
  })
  const spread = (r <= (rows / 2) ? r : rows - r) * 0.5
  const s = (rand([0.2]) + ((spread) * 0.05)) * len
  return (
    <group position={[p.x, p.y, p.z]} rotation={[t.x, t.y, t.z]}>
      <group ref={ref}>
        <group rotation={[0, (r * 0.02) + ((Math.PI * 2) / 4) * c, 0]}>
          <group position={[0.0001 * (spread + 1), 0, 0]} scale={[s * width, s, s]}>
            <Instance ref={inst} renderOrder={500} color={modCol ? (r % 2 === 0 ? cols[1] : cols[0]) : accent} />
          </group>
        </group>
      </group>
    </group>
  )
}

function Wirl({ geo, geo2, seq, col }) {
  const ref = useRef();
  const mat = useRef();
  useFrame(() => {
    mat.current.opacity = opacities[seq]
  })
  return (
    <>
      <mesh ref={ref} geometry={geo} position={[feats.wild ? (-0.001 * randI(6)) : -0.001, 0, 0]}>
        <meshBasicMaterial ref={mat} castShadow depthWrite={false} transparent opacity={0} color={rand(cols)} />
      </mesh>
      <mesh geometry={geo2} >
        <meshBasicMaterial depthTest={false} color={feats.wild ? rand(cols) : accent} />
      </mesh>
    </>
  )
}

const trackGeo = new THREE.OctahedronBufferGeometry(mobile ? 0.0005 : 0.00035, 1)
function Track({ seq, spline }) {
  const ref = useRef();
  const ref2 = useRef();
  const mat = useRef();
  const currProg = useRef(1);
  useFrame(() => {
    if (typeof currProg.current !== 'number') {
      return
    }
    currProg.current = started ? lerp(currProg.current, progress['p' + seq], feats.wild ? 0.005 : 0.02) : currProg.current
    const t = spline.getTangentAt(1 - currProg.current)
    const p = spline.getPointAt(1 - currProg.current)

    ref.current.rotation.x = t.x
    ref.current.rotation.y = t.y + (Math.PI * 0.25)
    ref.current.rotation.z = t.z + (Math.PI)
    ref2.current.position.x = p.x
    ref2.current.position.y = p.y
    ref2.current.position.z = p.z
  })
  return (
    <group ref={ref2}>
      <mesh ref={ref} geometry={trackGeo}>
        <meshBasicMaterial ref={mat} color={cols[0]} />
      </mesh>
    </group>
  )
}

function Top({ topTangent, topPos, geo, seq, col, len }) {
  const ref = useRef()
  const s = len + 0.2
  let c = rand(cols)
  return (
    <group scale={[s, s, s]} rotation={[topTangent.x + (Math.PI * 0.25), topTangent.y, topTangent.z]} position={[topPos.x, topPos.y, topPos.z]} >
      <group ref={ref} >
        {new Array(feats.petals).fill().map((_, i) =>
          <group rotation={[Math.PI * (1 / feats.petals) * i, 0, 0]} key={i}>
            {
              <mesh geometry={geo} renderOrder={10000}>
                <meshBasicMaterial depthWrite={false} color={c} side={THREE.DoubleSide} depthTest={false} />
                <Edges color={c} scale={1 + (0.05 * (randI(6) + 1))} />
              </mesh>
            }
          </group>
        )}
      </group>
    </group>
  )
}

function Balls({ topTangent, topPos, geo, seq, col, len }) {
  const ref = useRef()
  const s = (len + 0.1)
  let c = rand(cols)
  let offset = 10 + randI(43)
  return (
    <group scale={[s, s, s]} rotation={[topTangent.x + (Math.PI * 0.5), topTangent.y, topTangent.z]} position={[topPos.x, topPos.y + 0.0004, topPos.z]} >
      <group ref={ref} >
        <mesh geometry={geo}>
          <meshBasicMaterial depthWrite={false} color={c} />
        </mesh>
      </group>
    </group>
  )
}

function hexToRgbA(hex, o) {
  var c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length == 3) { c = [c[0], c[0], c[1], c[1], c[2], c[2]] }
    c = '0x' + c.join('');
    return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + o + ')';
  }
}

let moonSize = 6 + randI(18) * (mobile ? 1 : 0.7)
let posY = rand([20, 20, 25, 30, 35])
let posX = rand([20, 30, 40, 50, 60, 70, 80])
const root = document.getElementById('root');
root.style.background = bgColor
let rat = window.innerHeight / window.innerWidth
ReactDOM.createRoot(root).render(
  <>
    <div id="back" style={{
      borderWidth: rand([0.8, 0.8, 0.5, 0.5, (mobile ? 0.5 : 0.3)]) + 'vw',
      width: ((moonSize) / rat) + 'vh',
      height: ((moonSize) / rat) + 'vh',
      left: (posX + (((posX - 50) / 50) * 0.5)) + 'vw',
      top: posY + 'vh',
      borderColor: hexToRgbA(rand(cols), defaultOpacity),
    }} />
    <div id="back2" style={{
      borderWidth: rand([1, 2]) + 'px',
      width: (moonSize / rat) + 'vh',
      height: (moonSize / rat) + 'vh',
      left: posX + 'vw',
      top: posY + 'vh',
      borderColor: hexToRgbA(rand(cols), 1),
    }} />
    <App />
  </>
)
console.log('🌞🌱 @ramioso 2022-04-16 🌱🌞')